import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { FeaturedProperties } from "@/components/FeaturedProperties";
import ServicesSection from "@/components/ServicesSection";
import { DestinationsSection } from "@/components/DestinationsSection";
import GlobalNetworkSection from "@/components/GlobalNetworkSection";
import { HeritageSection } from "@/components/HeritageSection";

import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import { AboutSection } from "@/components/AboutSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <Navbar />
      <HeroSection />
      <FeaturedProperties />
      <ServicesSection />
      <DestinationsSection />
      <GlobalNetworkSection />
      <HeritageSection />
      
      <TestimonialsSection />
      <FAQSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default Index;
